import { isNotValidId } from 'utils/predicates/fields.util';

import fromAnyToBool from '../converters/fromAnyToBool.util';
import fromAnyToString from '../converters/fromAnyToString';

const checkSupportSalon = ({ salons, salonId }) => {
  if (!salons) {
    // null is the initial value,
    // no true/false means no info from BE
    return null;
  }

  if (isNotValidId(salonId)) {
    // treat invalid and missing id the same as not having BE info
    return null;
  }

  return fromAnyToBool(salons[fromAnyToString(salonId)]);
};

export default checkSupportSalon;
